interface ServiceTileProps {
  serviceKey: string;
  name: string;
  icon: string;
  url: string;
}

function ServiceTile({ serviceKey, name, icon, url }: ServiceTileProps) {
  return (
    <li className="service-tile">
      <a
        id={`${serviceKey}Tile`}
        className="tile-url"
        href={url}
        data-spotlight-popover={`service-tile-${serviceKey}`}
      >
        <div className="tile">
          <div className="tile-image">
            <img alt="" src={icon} className="tile-icon" />
          </div>
          <div className="tile-name text-ds-blue-10">{name}</div>
        </div>
      </a>
    </li>
  );
}

export default ServiceTile;
